import React from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const CalendarNotification = () => (
  <li className="message">
    <div className="calendar-notification-message-container">
      <div className="calendar-notification-message-header">
        <CalendarTodayIcon />
        <span className="calendar-notification-message-title">
          Live Show Alert
        </span>
      </div>
      <p>My show will start in 1 hour! I'm getting ready for you... Don't miss it, it won't be the same without you!</p>
    </div>
  </li>
)

export default CalendarNotification;
